export default __webpack_public_path__ + "static/media/kosterina-masterImage.08b90056.webp";